// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as RescriptRelay from "rescript-relay/src/RescriptRelay.re.mjs";

let Types = {};

function convertFragment(value) {
  return RescriptRelay.convertWithoutPlan(value, undefined);
}

let Internal = {
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeAmericanOrders_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 5
        }
      ],
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "americanOrders",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sku",
          "storageKey": null
        }
      ],
      "storageKey": "americanOrders(first:5)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

export {
  Types,
  Internal,
  Utils,
  node,
}
/* RescriptRelay Not a pure module */
